import { render, staticRenderFns } from "./BestSeller.vue?vue&type=template&id=e68abcd8&scoped=true&"
import script from "./BestSeller.vue?vue&type=script&lang=js&"
export * from "./BestSeller.vue?vue&type=script&lang=js&"
import style0 from "./BestSeller.vue?vue&type=style&index=0&id=e68abcd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68abcd8",
  null
  
)

export default component.exports